import reducer from './reducer'
import * as InboxOperations from './operations'
import * as InboxUtils from './utils'
import * as InboxTypes from './types'
import * as InboxActions from './actions'

export { InboxOperations, InboxUtils, InboxTypes, InboxActions }

export default reducer
